export const TOGGLE_DIET_FILTER: string = '[foods] Toggle Diet Filter';

export const toggleDietFilter = (id: string) => ({
  type: TOGGLE_DIET_FILTER,
  payload: id,
});
